export default __webpack_public_path__ + "static/media/realtime-gray.c0e68b3b.svg";